import { Vector2 } from "../../common/vector2.js";
import { audioController } from "../../audio/audio_controller.js";
import { AudioClips } from "../../audio/audio_constants.js";
import { AuthSessionStore } from "../../api/auth_session.js";
import { FriendsCache } from "../../friends/friends_cache.js";
import { Game } from "../../game.js";
import { ImagesHolder } from "../../image_loader/images_holder.js";
import { ImgID } from "../../image_loader/img_id.js";
// import { LevelAssetsController } from "../../level_assets_controller.js";
import { ScreenManager, Screens } from "../../screen_manager/screen_manager.js";
import { NetworkManager } from "../../network_manager.js";
import { StatisticsStorage } from "../../storage/statistics_storage.js";
import { TelegramAPISettings } from "../../telegram_api_settings.js";
import { BasicEventsController } from "../../touch_events_controller/basic_events_controller.js";
import { TransformScale } from "../../transforms/transform_scale.js";
import { TransformStraightMove } from "../../transforms/transform_straight_move.js";
import { ColorScheme } from "../common_ui_elements/color_scheme.js";
import { TextStyleScheme } from "../common_ui_elements/text_style_scheme.js";
import { UIElement } from "../common_ui_elements/ui_element.js";
import { UIGradientOverlay } from "../common_ui_elements/ui_gradient_overlay.js";
import { UIImage } from "../common_ui_elements/ui_image.js";
import { UINineSliceElement } from "../common_ui_elements/ui_nine_slice_element.js";
import { RoundedRectangle } from "../common_ui_elements/rounded_rectangle.js";
import { MyTextAlign, MyTextVerticalAlign, UITextElement } from "../common_ui_elements/ui_text_element.js";
import { OverlayFactory } from "../overlay/overlay_factory.js";
import { OverlayId } from "../overlay/overlay_ids.js";
import { OverlayManager } from "../overlay/overlay_manager.js";
import { SafeAreas } from "../safe_areas.js";
import { SoonTooltip } from "../tooltip/soon_tooltip.js";
import { TooltipManager } from "../tooltip/tooltip_manager.js";
import { NavigationItem } from "./navigation_item.js";
// import { VfxManager } from "../../webgl/vfx_manager.js";
import { randomRange } from "../../common/common_funcs.js";
// import { IController, StopBehavior } from "../../webgl/core/types/controller_types.js";

export class NavigationBlock extends UIElement
{
  private static readonly NAV_BAR_HEIGHT_DESIGN = 297;
  private static readonly MAIN_BG_W_DESIGN = 394;
  // The arch's yellow shoulders (source rows 62-75) continue the bar's
  // yellow top line, so the plate starts that far above the bar.
  private static readonly MAIN_BG_ABOVE_BAR_DESIGN = 62;

  private events_controller!: BasicEventsController;

  private current_index = 1;

  private items: NavigationItem[] = [];
  private main_bg!: UINineSliceElement;

  private readonly ITEM_IDS = [ImgID.IconNavigationLeaderboard, ImgID.IconNavigationMenu, ImgID.IconNavigationFriends];
  private readonly ITEM_TEXTS = ["LEADERBOARD", "GAME", "FRIENDS"];
  // All three are persistent screen tabs. (Settings moved to a gear button on
  // the menu screen; leaderboard is now the third nav tab.)
  private readonly ITEM_SCREENS: Array<Screens | null> = [Screens.LEADERBOARD, Screens.MENU, Screens.FRIENDS];
  // Leaderboard was locked ("soon") until it moved to the game server.
  private readonly ITEM_LOCKED = [false, false, false];
  private readonly MAIN_GAP_Y = 96;
  private static readonly FRIENDS_POLL_MS = 60_000;

  private friends_poll_at = -NavigationBlock.FRIENDS_POLL_MS;
  private friends_polling = false;
  private friends_gifts_count = 0;

  // private static readonly MIN_VFX_GLOWS_COUNT = 1;
  // private static readonly MAX_VFX_GLOWS_COUNT = 3;
  // private static readonly VFX_GLOWS_INTERVAL = 3200;
  // private last_vfx_time = -99999;
  // private active_vfx_controllers: { controller: IController, expires_at: number }[] = [];

  constructor(
    ctx: CanvasRenderingContext2D,
    x: number,
    y: number,
    width: number,
    height: number,
  )
  {
    super( ctx, x, y, width, height, false, false );

    this.initializeEventsController( this.ctx.canvas );

    this.createBackground();
    this.createContent();
  }

  private createBackground(): void
  {
    console.log('NavigationBlock.createBackground');

    const x = 0;
    const content_h = this.rect.getH() - Game.safeAreaBottom();
    const is_telegram = TelegramAPISettings.isTelegramEnvironment();
    // The bar is laid out as if there were no safe area and then lifted by
    // it; only its background runs on through the safe area to the screen edge.
    const bar_h = LayoutScaler.heightFromDesign( NavigationBlock.NAV_BAR_HEIGHT_DESIGN );
    const y = content_h - bar_h;
    const w = this.rect.getW();
    const h = this.rect.getH() - y;

    if ( is_telegram && Game.safeAreaLeft() > 0 )
    {
      const left_safe_area = new RoundedRectangle(
        this.ctx, -Game.safeAreaLeft(), 0,
        Game.safeAreaLeft(), this.rect.getH(),
        0, "#0139CD"
      );
      left_safe_area.setClickable( false );
      this.addChild( left_safe_area );
    }

    if ( is_telegram && Game.safeAreaRight() > 0 )
    {
      const right_safe_area = new RoundedRectangle(
        this.ctx, w, 0,
        Game.safeAreaRight(), this.rect.getH(),
        0, "#0139CD"
      );
      right_safe_area.setClickable( false );
      this.addChild( right_safe_area );
    }

    const bg = new UINineSliceElement(
      this.ctx,
      x,
      y,
      w,
      h,
      ImgID.UI_NavigationBg,
      "navigation_bg"
    );
    
    this.addChild( bg );
  }

  private async openCollection()
  {
    // const completed_levels = StatisticsStorage.load().completed_levels;
    // const stage = 1;

    // const images = completed_levels.map( level => LevelAssetsController.getImageId( level, stage ) );
    // const has_images = images.every( image => ImagesHolder.hasImage( image ) );

    // if ( has_images )
    // {
      // ScreenManager.showScreen( Screens.COLLECTION );

    //   return;
    // }

    // OverlayFactory.openOverlay( OverlayId.LOADING_OVERLAY );

    // for ( const level of completed_levels )
    // {
    //   await LevelAssetsController.loadLevelImage( level, stage );
    // }

    // OverlayManager.closeOverlay();

    // ScreenManager.show( Screens.COLLECTION );
  }

  private async openCalendar()
  {
    // const images = LevelAssetsController.getCalendarImageIds();
    // const has_images = images.every( image => ImagesHolder.hasImage( image ) );

    // if ( has_images )
    // {
    //   ScreenManager.show( Screens.CALENDAR );
    //   this.items.every( item => item.hideMsgIcon() );

    //   return;
    // }

    // OverlayFactory.openOverlay( OverlayId.LOADING_OVERLAY );

    // await LevelAssetsController.loadCalendarImages();

    // OverlayManager.closeOverlay();

    // ScreenManager.show( Screens.CALENDAR );
    // this.items.every( item => item.hideMsgIcon() );
  }

  private createContent(): void
  {
    const w = LayoutScaler.widthFromDesign( 340 );
    const h = LayoutScaler.heightFromDesign( NavigationBlock.NAV_BAR_HEIGHT_DESIGN );
    const content_bottom = this.rect.getH() - Game.safeAreaBottom();

    const count = this.ITEM_IDS.length;

    const spacing =
      ( this.rect.getW() - count * w )
      / ( count + 1 );

    for ( let i = 0; i < count; i++ )
    {
      const x = spacing + i * ( w + spacing );
      const y = content_bottom - h;

      const item = new NavigationItem(
        this.ctx,
        x,
        y,
        w,
        h,
        this.ITEM_IDS[i],
        this.ITEM_TEXTS[i],
        i === 0,
        this.ITEM_LOCKED[i]
      )

      this.items.push( item );

      if ( this.ITEM_LOCKED[i] )
      {
        item.setOnClick( () => this.showSoonTooltip( item ) );
        continue;
      }

      item.setOnClick( async () =>
      {
        console.log('NavigationBlock.onClick', i );

        const screen = this.ITEM_SCREENS[i];

        if ( screen === null || this.current_index === i )
          return;

        void audioController.playSound( AudioClips.UI_CLICK );

        if ( screen === Screens.LEADERBOARD && !NetworkManager.isOnline() )
        {
          NetworkManager.showOfflineLeaderboard();
          return;
        }

        ScreenManager.showScreen( screen );

        this.hideMain( this.current_index );
        this.current_index = i;
        this.createNewMain();
      } );
    }

    const bg_w = LayoutScaler.widthFromDesign( NavigationBlock.MAIN_BG_W_DESIGN );
    const image = this.items[this.current_index];
    const bg_x = image.pixelPosForRender().x + image.getRect().getW2() - bg_w / 2;
    const bar_top = content_bottom - h;
    const bg_y = bar_top - LayoutScaler.yFromDesign( NavigationBlock.MAIN_BG_ABOVE_BAR_DESIGN );
    const bg_h = this.rect.getH() - bg_y;

    const bg = new UINineSliceElement(
      this.ctx,
      bg_x,
      bg_y,
      bg_w,
      bg_h,
      ImgID.UI_NavigationMainBg,
      "selected_tab_nav"
    );

    this.main_bg = bg;

    this.addChild( bg );
    this.createNewMain( true );

    this.items.forEach( item =>
    {
      this.addChild( item );
    } );
  }

  public updateScreenBlock(): void
  {
    const current_screen = ScreenManager.getCurrentScreen();

    if ( !current_screen || !this.ITEM_SCREENS.includes( current_screen ) || this.ITEM_SCREENS.indexOf( current_screen ) === this.current_index )
      return;

    // this.clearActiveVfx();
    this.hideMain( this.current_index );
    this.current_index = this.ITEM_SCREENS.indexOf( current_screen );
    this.createNewMain();
  }

  private createNewMain( is_init = false ): void
  {
    const item = this.items[this.current_index];
    item.doMain( is_init );

    const new_bg_x = item.pixelPosForRender().x + item.getRect().getW2() - this.main_bg.getRect().getW2();
    this.main_bg.setPixelPos( new Vector2( new_bg_x, this.main_bg.pixelPosForRender().y ), true );
  }

  private showSoonTooltip( item: NavigationItem ): void
  {
    if ( TooltipManager.isAnyTooltipOpened() )
      return;

    void audioController.playSound( AudioClips.UI_CLICK );

    const icon = item.getIconRect();
    const nav_canvas = this.ctx.canvas;
    const tooltip_canvas = TooltipManager.ctx.canvas;
    const offset_x = parseFloat( nav_canvas.style.left || "0" ) - parseFloat( tooltip_canvas.style.left || "0" );
    const offset_y = parseFloat( nav_canvas.style.top || "0" ) - parseFloat( tooltip_canvas.style.top || "0" );
    const anchor_x = offset_x + icon.x + icon.width / 2;
    const anchor_top = offset_y + icon.y;

    const tooltip = SoonTooltip.create(
      TooltipManager.ctx,
      anchor_x,
      anchor_top,
      () => TooltipManager.closeTooltip()
    );

    TooltipManager.openTooltip( tooltip, true );
  }

  private hideMain( index: number ): void
  {
    const item = this.items[index];
    item.doDefault();
  }

  public name(): string
  {
    return "NavigationBlock";
  }

  public update( now: number ): void
  {
    super.updateBasic( now );

    if ( this.ctx.canvas.style.display === "none" )
      return;

    this.pollFriendsGifts( now );
    this.syncFriendsIndicator();

    // this.active_vfx_controllers = this.active_vfx_controllers.filter( item => item.expires_at > now );

    // if ( now - this.last_vfx_time > NavigationBlock.VFX_GLOWS_INTERVAL )
    // {
    //   const pre_warm = this.last_vfx_time === -99999;
    //   this.last_vfx_time = now;
    //   this.spawnGlows( now, pre_warm );
    // }
  }

  private pollFriendsGifts( now: number ): void
  {
    if ( this.friends_polling || now - this.friends_poll_at < NavigationBlock.FRIENDS_POLL_MS )
      return;

    if ( AuthSessionStore.getPlayerId() === null || !NetworkManager.isOnline() || document.hidden )
      return;

    this.friends_poll_at = now;
    this.friends_polling = true;

    FriendsCache.fetch()
      .catch( e => console.warn( "[NavigationBlock] Failed to refresh friends gifts", e ) )
      .finally( () => { this.friends_polling = false; } );
  }

  private syncFriendsIndicator(): void
  {
    const gifts_count = FriendsCache.peek()?.gifts.length ?? 0;

    if ( gifts_count === this.friends_gifts_count )
      return;

    this.friends_gifts_count = gifts_count;
    this.items[this.ITEM_SCREENS.indexOf( Screens.FRIENDS )].setIndicator( gifts_count );
  }

  // private spawnGlows( now: number, pre_warm: boolean = false ): void
  // {
  //   if ( !this.main_bg )
  //     return;

  //   const count = Math.round( randomRange( NavigationBlock.MIN_VFX_GLOWS_COUNT, NavigationBlock.MAX_VFX_GLOWS_COUNT ) );

  //   const bg_rect = this.main_bg.getRect();
  //   const bg_pos = this.main_bg.getAbsolutePosition();
    
  //   const canvas_y_offset = Game.screenH() - ( LayoutScaler.yFromDesign( 250 ) + Game.safeAreaBottom() ) - Game.safeAreaTop();

  //   const w_factor = bg_rect.getW() * 0.6;
  //   const h_factor = bg_rect.getH() * 0.6;
  //   const offset_x = bg_rect.getW() * 0.2;
  //   const offset_y = bg_rect.getH() * 0.2;

  //   for ( let i = 0; i < count; i++ )
  //   {
  //     const rx = bg_pos.x + offset_x + Math.random() * w_factor;
  //     const ry = bg_pos.y + offset_y + Math.random() * h_factor;
  //     const start_time = pre_warm ? now - Math.random() * 4000 : now + Math.random() * NavigationBlock.VFX_GLOWS_INTERVAL;

  //     const controller = VfxManager.spawnNavigationButtonGlow( new Vector2( rx, ry + canvas_y_offset ), start_time, { x: bg_pos.x, y: bg_pos.y + canvas_y_offset, w: bg_rect.getW(), h: bg_rect.getH() }, { intensity: 2, min_size: 40, max_size: 60 } );
  //     if ( controller )
  //       this.active_vfx_controllers.push( { controller, expires_at: start_time + 4000 } );
  //   }
  // }

  // public resetGlowTimer(): void
  // {
  //   this.last_vfx_time = 0;
  // }

  public render(): void
  {
    if ( !this.shouldBeRendered() )
      return;

    this.ctx.clearRect( -Game.safeAreaLeft(), -Game.safeAreaTop(), Game.screenW() + Game.safeAreaLeft() + Game.safeAreaRight(), Game.screenH() + Game.safeAreaTop() + Game.safeAreaBottom() );

    this.startRender();
    this.finishRender();

    // The screens under this canvas draw their own bottom safe-area tint, but
    // the bar covers it, so the bar draws it again on top of itself. After
    // finishRender the ctx is back at the canvas origin, and the canvas is
    // exactly this block's height.
    SafeAreas.renderBottomSafeAreaOverlay( this.ctx, this.rect.getH() );
  }

  private initializeEventsController( canvas: HTMLCanvasElement ): void
  {
    if ( this.events_controller )
      this.events_controller.cleanup();

    this.events_controller = new BasicEventsController( canvas );

    this.events_controller.init(
      ( p: Vector2 ) => super.onTouchStart( p, performance.now() ),
      ( p: Vector2 ) => super.onTouchEnd( p, performance.now() ),
      ( p: Vector2 ) => super.onTouchMove( p, performance.now() )
    );
  }

  // public clearActiveVfx(): void
  // {
  //   this.active_vfx_controllers.forEach( item => item.controller.stop( StopBehavior.ClearInstances ) );
  //   this.active_vfx_controllers = [];
  // }

  public destroy(): void
  {
    console.log( 'NavigationBlock.destroy' );

    // this.clearActiveVfx();

    if ( this.events_controller )
    {
      this.events_controller.cleanup();
      this.events_controller = null as any;
    }
  }
}
